// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-content__title{
    background: var(--white-color);
    border-bottom: 1px solid var(--new-gray-background-color);
    border-top: 1px solid var(--new-gray-background-color);
    padding: 16px 30px;
}
.edit-content__title.baloa-subtitle-2{
    color: var(--primary-very-dark-color);
}
.edit-content__title__text{
    font-family: var(--primary-font) !important;
    font-style: normal;
    font-weight: var(--font-medium) !important;
    font-size: 21px !important;
    line-height: var(--space-and-half) !important;
    letter-spacing: 0.015em !important;
    color: var(--primary-very-dark-color) !important;
}

.edit-content__content {
    margin-top: 24px;
    width: 70%;
    margin-left: auto;
    margin-right: auto;
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.edit-content__info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--space) var(--space-and-half);
    border-bottom: 1px solid var(--new-gray-background-color);
}

.edit-content__info:last-child{
    border-bottom: none;
}

.edit-content__info .hubicon-edit1 {
    font-size: 24px;
    color: var(--primary-dark-color);
    cursor: pointer;
}

.edit-content__info-data .baloa-normal-medium {
    color: var(--primary-very-dark-color);
}

.edit-content__info-data .baloa-names {
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
    margin-top: 6px;
}

.edit-content__text{
    width: 70%;
}
.edit-content__text.baloa-names{
    color: var(--basic-gray-color);
}

.edit-content__button {
    width: 10%;
    cursor: pointer;
}
.edit-content__info__content{
    width: 30%;
}
.edit-content__info__content.baloa-names{
    color: var(--primary-dark-color);
}
.edit-content__button__text.baloa-hyperlink-2 {
    color: var(--new-green-color);
}
.tabEdit-content {
    margin: 0;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .edit-content__mobile-info {
        display: flex;
        flex-direction: column;
    }
    .edit-content__mobile-info .edit-content__info__content {
        margin-bottom: calc( var(--space) + 2px );
    }
    .edit-content__info__content.email {
        white-space: nowrap;
    }
    .edit-content__info {        
        padding-bottom: calc( var(--space) + var(--space-quarter) + 1px );
    }

    .edit-content__content {
        margin: 12px;
        width: calc(100vw - 24px);
    }
}`, "",{"version":3,"sources":["webpack://./src/app/user-settings/components/account-information/AccountInformationComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,yDAAyD;IACzD,sDAAsD;IACtD,kBAAkB;AACtB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,0CAA0C;IAC1C,0BAA0B;IAC1B,6CAA6C;IAC7C,kCAAkC;IAClC,gDAAgD;AACpD;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;IAC3C,yDAAyD;AAC7D;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;AACA;IACI,UAAU;AACd;AACA;IACI,gCAAgC;AACpC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,SAAS;AACb;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,yCAAyC;IAC7C;IACA;QACI,mBAAmB;IACvB;IACA;QACI,iEAAiE;IACrE;;IAEA;QACI,YAAY;QACZ,yBAAyB;IAC7B;AACJ","sourcesContent":[".edit-content__title{\n    background: var(--white-color);\n    border-bottom: 1px solid var(--new-gray-background-color);\n    border-top: 1px solid var(--new-gray-background-color);\n    padding: 16px 30px;\n}\n.edit-content__title.baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n}\n.edit-content__title__text{\n    font-family: var(--primary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-medium) !important;\n    font-size: 21px !important;\n    line-height: var(--space-and-half) !important;\n    letter-spacing: 0.015em !important;\n    color: var(--primary-very-dark-color) !important;\n}\n\n.edit-content__content {\n    margin-top: 24px;\n    width: 70%;\n    margin-left: auto;\n    margin-right: auto;\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.edit-content__info {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--space) var(--space-and-half);\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.edit-content__info:last-child{\n    border-bottom: none;\n}\n\n.edit-content__info .hubicon-edit1 {\n    font-size: 24px;\n    color: var(--primary-dark-color);\n    cursor: pointer;\n}\n\n.edit-content__info-data .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n}\n\n.edit-content__info-data .baloa-names {\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n    margin-top: 6px;\n}\n\n.edit-content__text{\n    width: 70%;\n}\n.edit-content__text.baloa-names{\n    color: var(--basic-gray-color);\n}\n\n.edit-content__button {\n    width: 10%;\n    cursor: pointer;\n}\n.edit-content__info__content{\n    width: 30%;\n}\n.edit-content__info__content.baloa-names{\n    color: var(--primary-dark-color);\n}\n.edit-content__button__text.baloa-hyperlink-2 {\n    color: var(--new-green-color);\n}\n.tabEdit-content {\n    margin: 0;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .edit-content__mobile-info {\n        display: flex;\n        flex-direction: column;\n    }\n    .edit-content__mobile-info .edit-content__info__content {\n        margin-bottom: calc( var(--space) + 2px );\n    }\n    .edit-content__info__content.email {\n        white-space: nowrap;\n    }\n    .edit-content__info {        \n        padding-bottom: calc( var(--space) + var(--space-quarter) + 1px );\n    }\n\n    .edit-content__content {\n        margin: 12px;\n        width: calc(100vw - 24px);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
